var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContentPrivate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 30,
    viewBox: "0 0 59 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 59,
    height: 30,
    rx: 2,
    fill: "#FEECEC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.1094 8.32812V22.3594H19.625V8.32812H21.1094ZM11.7812 9.5V13.0938H15.5469V9.5H17.0156V19H10.2969V9.5H11.7812ZM11.7812 17.7812H15.5469V14.2656H11.7812V17.7812ZM29.2563 17.125C32.2875 17.125 34.1938 18.0781 34.2094 19.7188C34.1938 21.3438 32.2875 22.3125 29.2563 22.2969C26.2563 22.3125 24.3344 21.3438 24.3344 19.7188C24.3344 18.0781 26.2563 17.125 29.2563 17.125ZM29.2563 18.25C27.1313 18.25 25.8031 18.7969 25.8188 19.7188C25.8031 20.625 27.1313 21.1562 29.2563 21.1562C31.3969 21.1562 32.725 20.625 32.7406 19.7188C32.725 18.7969 31.3969 18.25 29.2563 18.25ZM34.1 9.01562V10.1875C34.1 11.3125 34.1 12.4688 33.7094 13.9062L32.2563 13.75C32.6313 12.3203 32.6313 11.2891 32.6313 10.2031H24.4438V9.01562H34.1ZM35.6938 14.7656V15.9688H22.9594V14.7656H28.0688V12.1406H29.5219V14.7656H35.6938ZM48.3563 8.32812V22.3281H46.9344V15.0625H45.2V21.6562H43.8094V8.70312H45.2V13.8594H46.9344V8.32812H48.3563ZM42.4188 10.1094C42.4031 13.7969 41.1844 17.0938 37.1844 19.3594L36.325 18.3281C39.4344 16.5703 40.7469 14.1875 40.9813 11.3281H36.9188V10.1094H42.4188Z",
    fill: "#FF4242"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContentPrivate);
export default __webpack_public_path__ + "static/media/content-private.93dbf6c1cc0c751603a46793d9513d84.svg";
export { ForwardRef as ReactComponent };